export class AbosAccount {
  accountId: string;
  accountName: string;
  publicKey: string;
  privateKey: string;
  extSourceCode: string;
  externalAccountId: number | string | null;

  constructor(accountId: string,
              accountName: string,
              publicKey: string,
              privateKey: string,
              extSourceCode: string,
              externalAccountId: number | string | null) {
    this.accountId = accountId;
    this.accountName = accountName;
    this.publicKey = publicKey;
    this.privateKey = privateKey;
    this.extSourceCode = extSourceCode;
    this.externalAccountId = externalAccountId;
  }
}
